<template>
 <nav class="navbar">
<div @click="$router.push('/')"  class="logo" >
<img id="Logo"  src="../../assets/Logo.png" alt="">
</div>
<!-- <transition-group tag="a" name="modal" class="toggle-button" @click.prevent="seen = !seen"> -->
<a href="" class="toggle-button background" @click.prevent="seen = !seen">
    <span class="baro" v-if="!seen">
  <span class="bar"></span>
  <span class="bar"></span>
  <span class="bar"></span>
  </span>
   <div class="navbar_cross baro"  v-else>
<img  src="../../assets/navbar_cross.png" alt="">
  </div>
 
</a>

<!-- </transition-group> -->
<div v-if="seen" class="navbar-links" >
    <ul >
        <li> <router-link  :to="{name: 'Home'}">Home</router-link></li>
        <li >  <router-link :to="{name: 'ourPrograms'}">Our Programs</router-link> </li>
        <li> <router-link :to="{name: 'BecomeATeacher'}">Become a Teacher</router-link> </li>
        <li> <router-link :to="{name: 'AboutUs'}">About Us/Our Story</router-link> </li>
        <li> <router-link :to="{name: 'Shop'}">Shop</router-link> </li>
        <li> <router-link :to="{name: 'Blogs'}">Blogs</router-link> </li>
    </ul>
</div>
  </nav>

 
</template>

<script>


export default {
data(){
  return{
    seen: true
  }
},
mounted () {
  window.scrollTo(0, 0)
  
}
}
</script>

<style scoped>


.navbar_cross{
width: 100%;
height: auto;
/* margin-top: 25px; */
margin-left: 5px;
}



.router-link-active{
   background: #791E94 ;
  color: white !important;
   border-radius: 20px;
}
.navbar{
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #FFFFF2;
  color: white;
  position: fixed;
  width: 100%;
  z-index: 1500;
  top: 0;
}
.logo{
  font-size: 1.5rem;
  margin: .5rem;
 cursor: pointer;
}
#Logo{
   width: 100%;
  height: 100%;
   object-fit: cover;
   padding-right: 10px;
   padding-top: 10px;
}
.navbar-links ul {
  display: flex;
  
}
.navbar-links li{
  list-style: none;
  border-radius: 20px;
  
}

/* .navbar-links a:hover{
  color: white;
} */

/* .navbar-links li:hover{
  background: #791E94 ;
  color: white;
  transition: .2s all ease-in;
  
  
} */
/* .navbar-links li:active{
     background: #791E94 ;
  color: white;
  transition: .2s all ease-in;
} */
.navbar-links a{
  color: purple;
  text-decoration: none;
  display: block;
  padding: 13px 26px;
  font-size: 1.5rem;
  transition: .2s all ease-in;
  margin: 5px;
  border-radius: 20px;
}
.navbar-links a:hover{
  color: white;
   transition: .2s all ease-in;
  background: #791E94 ;

}
/* .navbar-links li:hover{
  background-color: #444;
} */
.toggle-button{
  position: absolute;
  top: .75rem;
  right: 1rem;
  display: none;
  justify-content: space-between;
  flex-direction: column;
  width: 30px;
  height: 21px;
  
}
.toggle-button .bar{
  height: 3px;
  width: 100%;
  background-color: #791E94;
  border-radius: 10px;
  margin-bottom: 5px;
  display: block;
}
.baro{
  /* margin-top: 25px; */
      position: relative;
    top: 20px;
    right: 10px;
    /* margin: 10px; */
}



@media (max-width: 1080px){
  .toggle-button{
    display: flex;
  }
  .navbar-links{
/* display: none; */
width: 100%;
  }
  .navbar{
flex-direction: column;
align-items: flex-start;
  }
  .navbar-links ul{
    flex-direction: column;
    width: 100%;
    align-items: center;
  }
  .navbar-links li {
    text-align: center;
  }
  .navbar-links a {
    padding: .5rem 1rem;
  }
  .navbar-links.active {
    display: flex;
  }
}
</style>